import axios from "axios";
import { baseUrl } from "./../utils/api";
const loginEndpoint = `${baseUrl}oath/login`;

export function loginCreation(payload) {
  return axios.post(loginEndpoint, payload);
}
